export default __webpack_public_path__ + "static/media/Dayananda.e719a28f.png";